export default "__VITE_ASSET__23bd6524__"